import service from './index'


const resourceFeedback = service.resource('feedback/search{ = startDate}{ = endDate}{ = trainerId}{ = page}{ = size}{ = sort}')

export default { 
  
  getFeedback(startDate,endDate,trainerId,page,size) {
    if(trainerId == 'All'){
      if(startDate && endDate && startDate != '' && endDate != '' && startDate != undefined && endDate != undefined){
        return resourceFeedback.get({startDate: startDate,endDate:endDate,page:page,size:size,sort:"runDateTime,desc"})
      }else{
        return resourceFeedback.get({page:page,size:size,sort:"runDateTime,desc"})
      }
    }
    else{
      if(startDate && endDate && startDate != '' && endDate != '' && startDate != undefined && endDate != undefined){
        return resourceFeedback.get({startDate: startDate,endDate:endDate,trainerId:trainerId,page:page,size:size,sort:"runDateTime,desc"})
      }else{
        return resourceFeedback.get({trainerId:trainerId,page:page,size:size,sort:"runDateTime,desc"})
      }
    }    
  },  
  
}




// WEBPACK FOOTER //
// ./src/services/feedback.js